import React from "react";
import Search from "../users/Search";
import Users from "../users/Users";

const Home = () => {
  return (
    <>
      <Search></Search>
      <Users></Users>
    </>
  );
};

export default Home;
